"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrganisationImage = exports.OrganisationImageDefaultProps = exports.OrganisationImageMaxWidths = exports.OrganisationImageMaxHeights = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var image_fill_1 = require("./image-fill");
var entity_embed_1 = require("./entity-embed");
// -------- Types -------->
exports.OrganisationImageMaxHeights = {
  small: '40px',
  embed: '60px',
  medium: '70px',
  large: '180px',
  veryLarge: '180px'
};
exports.OrganisationImageMaxWidths = {
  small: 'none',
  embed: 'none',
  medium: 'none',
  large: '300px',
  veryLarge: '300px'
};
exports.OrganisationImageDefaultProps = {
  size: 'large'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: #FFF;\n  "], ["\n    background: #FFF;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var isEmbed = _a.isEmbed;
    return isEmbed && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border: 2px solid ", ";\n    "], ["\n      border: 2px solid ", ";\n    "])), theme_1.theme.COLOR('app-chrome'));
  }),
  desktop: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n\n    ", "\n\n    ", "\n  "], ["\n    display: flex;\n    align-items: center;\n\n    ", "\n\n    ", "\n  "])), function (_a) {
    var isBanner = _a.isBanner,
      size = _a.size;
    return isBanner && size === 'medium' && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    "], ["\n    "])));
  }, function (_a) {
    var isBanner = _a.isBanner,
      size = _a.size;
    return isBanner && size === 'large' && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      margin: ", " 0;\n      ", ";\n    "], ["\n      margin: ", " 0;\n      ", ";\n    "])), theme_1.theme.UNIT(4), theme_1.theme.V_DOT_BG_END());
  })
});
var PadStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding: ", ";\n    display: flex;\n    align-items: center;\n    width: 100%;\n    box-sizing: border-box;\n  "], ["\n    padding: ", ";\n    display: flex;\n    align-items: center;\n    width: 100%;\n    box-sizing: border-box;\n  "])), theme_1.theme.UNIT(1)),
  tablet: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme_1.theme.UNIT(3)),
  desktop: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var isBanner = _a.isBanner,
      size = _a.size;
    return isBanner && size === 'medium' && (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      padding: 0 ", " 0 ", ";\n    "], ["\n      padding: 0 ", " 0 ", ";\n    "])), theme_1.theme.UNIT(4, 2), theme_1.theme.UNIT(3));
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Pad: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), PadStyles),
  Image: (0, styled_components_1.default)(image_fill_1.ImageFill)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), entity_embed_1.EntityEmbedImageStyles)
};
var OrganisationImage = function (props) {
  var className = props.className,
    entity = props.entity,
    isBanner = props.isBanner,
    isEmbed = props.isEmbed,
    size = props.size;
  var image = entity.logo || entity.openGraph && entity.openGraph.image;
  if (!image) {
    return null;
  }
  return react_1.default.createElement(My.Container, {
    size: size,
    isEmbed: isEmbed,
    isBanner: isBanner,
    className: className
  }, react_1.default.createElement(My.Pad, {
    size: size,
    isBanner: isBanner
  }, react_1.default.createElement(My.Image, {
    size: size,
    fit: "contain",
    entity: image
  })));
};
exports.OrganisationImage = OrganisationImage;
exports.OrganisationImage.defaultProps = exports.OrganisationImageDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;